<prism-badge [disabled]="notificationsCount() === 0" id="sh-header-toolbar-notifications-badge">
	<prism-icon-button
		icon="notifications"
		label="notifications"
		tooltip-disabled
		(click)="isNotificationsEnabled.set(!isNotificationsEnabled())"
		id="sh-header-toolbar-notifications-icon"
	>
	</prism-icon-button>
</prism-badge>
@if (isNotificationsEnabled()) {
	<sh-notifications-popup
		[application]="application"
		(closeNotificationPopup)="isNotificationsEnabled.set(false)"
	></sh-notifications-popup>
}
